export default __webpack_public_path__ + "static/media/bkg--agent.d774b4d6.jpg";